import {IdName} from '@domain/id-name';

export class BuggyForProductionSchedule extends IdName {
  private _amountPlannedInMeter: number;
  private _amountPlannedInPicks: number;

  public constructor(id: number, name: string, amountPlannedInMeter: number = 0, amountPlannedInPicks: number = 0) {
    super(id, name);
    this._amountPlannedInMeter = amountPlannedInMeter;
    this._amountPlannedInPicks = amountPlannedInPicks;
  }

  public get amountPlannedInMeter(): number {
    return this._amountPlannedInMeter;
  }

  public set amountPlannedInMeter(amountPlannedInMeter: number) {
    this._amountPlannedInMeter = amountPlannedInMeter;
  }

  public get amountPlannedInPicks(): number {
    return this._amountPlannedInPicks;
  }

  public set amountPlannedInPicks(amountPlannedInPicks: number) {
    this._amountPlannedInPicks = amountPlannedInPicks;
  }

  public static fromJSON(buggyForProductionScheduleJSON: any): BuggyForProductionSchedule {
    return new BuggyForProductionSchedule(
      buggyForProductionScheduleJSON.id,
      buggyForProductionScheduleJSON.name,
      buggyForProductionScheduleJSON.amountPlannedInMeter,
      buggyForProductionScheduleJSON.amountPlannedInPicks
    );
  }

  public static fromJSONForSchedule(buggyForProductionScheduleJSON: any): BuggyForProductionSchedule {
    return new BuggyForProductionSchedule(
      buggyForProductionScheduleJSON.id,
      buggyForProductionScheduleJSON.name,
      buggyForProductionScheduleJSON.amountPlannedInM,
      buggyForProductionScheduleJSON.amountPlannedInPicks
    );
  }

  public toJSON(): JSON {
    return {
      id: this.id,
      name: this.name,
      amountPlannedInMeter: this.amountPlannedInMeter,
      amountPlannedInPicks: this.amountPlannedInPicks
    } as any as JSON;
  }
}
